import type { EmptySearchCurrentState } from '@ve/components/emptySearch/common/store/types/IEmptySearchStore';

export default ({
    hasTours,
    loadingStateIsFinished,
}: {
    loadingStateIsFinished: boolean,
    hasTours: boolean;
}): EmptySearchCurrentState | null => {
    if (hasTours) {
        return 'defaultCriteriaSearchHasTours';
    }

    if (loadingStateIsFinished) {
        return 'defaultCriteriaSearchNoTours';
    }

    return null;
};